<template>
    <div class="title-base-mask">
        <div class="base-title">{{ title }}</div>
        <div class="base-content">
            <slot></slot>
        </div>
        <div class="buttons" v-show="showButton">
            <RoundButton class="btn" :text="cancelLabel" @btnClick="cancelClick" :cls="cls.cancelBtn"></RoundButton>
            <RoundButton class="btn" :text="confirmLabel" @btnClick="confirmClick" :cls="cls.confirmBtn"></RoundButton>
        </div>
        <a class="close-btn" @click="close"></a>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";

export default {
    name: "TitleBaseBox",
    props: ["title", "noButton", "cancelText", "confirmText"],
    components: {
        RoundButton
    },
    data() {
        return {
            cls: {
                cancelBtn: "cancel-btn",
                confirmBtn: "confirm-btn"
            }
        };
    },
    computed: {
        confirmLabel() {
            return this.confirmText || this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.cancelText || this.$t("zhiji.common.cancel");
        },
        showButton() {
            return !this.noButton;
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        cancelClick() {
            this.$emit("cancel");
            this.close();
        },
        confirmClick() {
            this.$emit("confirm");
        }
    }
};
</script>

<style lang="less" scoped>
.title-base-mask {
    display: flex;
    flex-direction: column;
    min-width: 300px;
    min-height: 150px;
    max-height: 70%;
    position: relative;
    border-radius: 8px;
    box-shadow: 0px 5px 8px rgba(90, 98, 111, 0.25);
    background: #fff;

    .base-title {
        padding: 4px 23px;
        font-size: 16px;
        background: #e4f1f9;
        border-radius: 8px 8px 0 0;
        box-sizing: border-box;
        height: 40px;
        line-height: 30px;
    }

    .base-content {
        padding: 20px;
        box-sizing: border-box;
        overflow-y: auto;
    }

    .buttons {
        display: flex;
        justify-content: flex-end;
        padding: 0 20px 20px;
        flex-grow: 0;
        flex-shrink: 0;

        .btn {
            margin-right: 8px;
        }
    }

    .close-btn {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        width: 44px;
        height: 40px;
        background: url("@{zhijiStaticImagePath}i-close.png") center center no-repeat;
    }
}
.cancel-btn {
    border: 1px solid #d8e4f0;
    box-shadow: none !important;
    background-color: #fff !important;
    color: rgba(65, 71, 94, 0.9) !important;
    &:hover {
        color: #2ec2ff !important;
    }
}

.confirm-btn {
    box-shadow: none !important;
}
</style>
